import Banner from "@/components/ui/banner/Banner";
import { stripHTML } from "@/utils/utils";

interface PageBannerProps {
  category: { name: string; description: string } | null;
  isLoading: boolean;
}

const PageBanner = ({ category, isLoading }: PageBannerProps) => {
  return (
    <Banner
      banner={{
        image: {
          default: "/images/shop/shop-banner.jpg",
          desktop: "/images/shop/shop-banner.jpg",
        },
        title: category?.name || "所有商品",
        description: stripHTML(category?.description || "") || "",
      }}
      heightClasses="h-[30vh] lg:h-[50vh]"
      isLoading={isLoading}
      skeletonSize="sm"
    />
  );
};

export default PageBanner;
